<app-nav-bar></app-nav-bar>
<app-box-setting></app-box-setting>
<!--<div [@routeAnimations]="prepareRoute(outlet)">-->
<!--    <router-outlet #outlet="outlet"></router-outlet>-->
<!--</div>-->
<router-outlet #outlet="outlet"></router-outlet>

